import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import AppMember from '@/components/Secretariat/Membre/AppMember'
import AppClub from '@/components/Secretariat/Club/AppClub'
import OperationMain from '@/components/Operations/OperationMain'
import MajOperations from '@/components/Operations/OperationMain'
import GenerationCourrier from '@/components/Outils/GenerationCourrier'
import GenerationFacture from '@/components/Outils/GenerationFacture'
import RechercheAvancee from '@/components/Outils/RechercheAvancee'
import InfosGenerales from '@/components/Outils/InfosGenerales'
import Compte from '@/components/Operations/Compte'
import AddNewMember from '@/components/Secretariat/Membre/AddNewMember'
import AddNewClub from '@/components/Secretariat/Club/AddNewClub'
import AppRecapitulatif from '@/components/Secretariat/Recapitulatif/AppRecapitulatif'
import AppFormation from '@/components/Secretariat/Formation/AppFormation'
import AppCompetition from '@/components/Secretariat/Competition/AppCompetition'
import AppCompetitionPoomsae from '@/components/Secretariat/CompetitionPoomsae/AppCompetitionPoomsae'
import ListingRecap from '@/components/Secretariat/Recapitulatif/ListingRecap'
import AppStatsGeneral from '@/components/Secretariat/Statistiques/General/AppStatsGeneral'
import AppRanking from '@/components/Secretariat/Ranking/AppRanking'
import AppAvertissement from '@/components/Secretariat/Avertissement/AppAvertissement'
import AppAdministration from '@/components/Administration/Administration'
import AppOrderMyABFT from '@/components/Secretariat/MyABFT/AppOrderMyABFT'
import AppProfile from '@/components/Administration/Profile'
import store from "../vuex/store";
import AppVerification from "../components/Secretariat/Verification/AppVerification";
import AppTest from "../components/AppTest";
import GenerationEtiquetteFlyer from "../components/Outils/GenerationEtiquetteFlyer";
import GenerationCarteCoach from "../components/Outils/GenerationCarteCoach";
import GenerationDiplome from "../components/Outils/GenerationDiplome";
import LabelisationGeneral from "@/components/Labelisation/Labelisation_general";
import MyABFTGeneral from "@/components/MyABFT/MyABFT_general";
import AdminNotifications from "@/components/Administration/AdminNotifications";
import ParametresFacturation from "@/components/Administration/ParametresFacturation";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: guardRoute,
      // meta: { bodyClass: 'skin-blue' },
    },
    {
      path: '/testABFT',
      name: 'test',
      component: AppTest,
      meta: { bodyClass: 'login-page' },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { bodyClass: 'login-page' },
    },
    {
      path: '/test',
      name: 'Test',
      component: ListingRecap,
      beforeEnter: guardRoute
    },
    {
      path: '/add-member',
      name: 'AddMembre',
      component: AddNewMember,
      beforeEnter: guardRoute
    },
    {
      path: '/add-club',
      name: 'AddClub',
      component: AddNewClub,
      beforeEnter: guardRoute
    },
    {
      path: '/membre/:member_id',
      name: 'Member',
      component: AppMember,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/club/:club_id',
      name: 'Club',
      component: AppClub,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/formation/:formation_id',
      name: 'Formation',
      component: AppFormation,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/competition/:competition_id',
      name: 'Competition',
      component: AppCompetition,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/competition-poomsae/:competition_id',
      name: 'CompetitionPoomsae',
      component: AppCompetitionPoomsae,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/recaptifulatif/:recap_id',
      name: 'Recap',
      component: AppRecapitulatif,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/comptabilite/operations',
      name: 'Operations',
      component: OperationMain,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/comptabilite/compte/:id_compte',
      name: 'Compte',
      component: Compte,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/comptabilite/majOperations',
      name: 'MajOperations',
      component: MajOperations,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/outils/courrier',
      name: 'Generation_courrier',
      component: GenerationCourrier,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/outils/etiquettes',
      name: 'Generation_etiquette',
      component: GenerationEtiquetteFlyer,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/outils/carte_coach_generator',
      name: 'Generation_carte_coach',
      component: GenerationCarteCoach,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/outils/diplome_generator',
      name: 'Generation_diplome',
      component: GenerationDiplome,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/outils/facture',
      name: 'Generation_facture',
      component: GenerationFacture,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/outils/recherche',
      name: 'RechercheAvancee',
      component: RechercheAvancee,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/outils/infosGenerales',
      name: 'InfosGenerales',
      component: InfosGenerales,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/statistiques/general',
      name: 'Statistiques_generales',
      component: AppStatsGeneral,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/liste_commandes_myabft/:order_id',
      name: 'Liste_commandes_myabft',
      component: AppOrderMyABFT,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/ranking',
      name: 'Ranking',
      component: AppRanking,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/verification/Verifications_competiteurs',
      name: 'Verifications_competiteurs',
      component: AppVerification,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/avertissements',
      name: 'Avertissements',
      component: AppAvertissement,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/administration',
      name: 'Administration',
      component: AppAdministration,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/profil',
      name: 'Profil',
      component: AppProfile,
      props: true,
      beforeEnter: guardRoute
    },
    {
      path: '/labelisation',
      name: 'Labelisation',
      component: LabelisationGeneral,
      beforeEnter: guardRoute
    },
    {
      path: '/myabft',
      name: 'MyABFT',
      component: MyABFTGeneral,
      beforeEnter: guardRoute
    },
    {
      path: '/admin/notifications',
      name: 'AdminNotifications',
      component: AdminNotifications,
      beforeEnter: guardRouteAdmin
    },
    {
      path: '/admin/facturation',
      name: 'ParametresFacturation',
      component: ParametresFacturation,
      beforeEnter: guardRouteAdmin
    },
  ]
})

function guardRoute(to, from, next) {
  var moment = require('moment')
  //on synchronise avec le local storage
  //Comme ça, s'il y a déjà eu une premiere connexion, on peut récuprérer le token et l'user
  //Si le localstorage est vide, on renvoie vers le login
  router.app.$options.store.commit('SYNC_DATA')
  // work-around to get to the Vuex store (as of Vue 2.0)
  const auth = router.app.$options.store.state.stateLocalStorage.syncedData.auth
  if (!auth.isLoggedIn || moment().isAfter(moment(auth.expires_in))) {
    // debugger;
    auth.isLoggedIn = false
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function guardRouteAdmin(to, from, next) {
  var moment = require('moment')
  router.app.$options.store.commit('SYNC_DATA')
  const auth = router.app.$options.store.state.stateLocalStorage.syncedData.auth
  const user = router.app.$options.store.state.stateLocalStorage.syncedData.user
  if (!auth.isLoggedIn || moment().isAfter(moment(auth.expires_in))) {
    auth.isLoggedIn = false
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else if (!user || !user.isAdmin) {
    next({ path: '/' })
  } else {
    next()
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/router.js